<!-- 页头 -->

<template>
  <!--
    header
      显示：(背景色, 登录/账户_颜色)
        首页：透明
        ——————————————————————
        个人中心： 兰
        ——————————————————————
        搜索结果及找回密码：白
      不显示:
        问题反馈及反馈结果
   -->
  <header v-show="showHeader"
          :class="{ 'pos_index': isIndex,
                    'pos_results': isResults,
                    'pos_personal': isPersonal,
                    'pos_feedback': isFeedback }">
    <div class="h_container">

      <!-- 搜索框 -->
      <div class="clearfix h_maincon_wrap" :style="{'display': $route.path =='/reset'?'none':''}">
        <router-link to="/" class="h_logo">
          <img src="../../assets/images/common/logo_white.png" v-if="isPersonal">
          <img src="../../assets/images/common/logo_black.png" v-else>
        </router-link>
        <div class="h_search_box">
          <input type="text" style="display:none" name="MD">
          <input type="text" placeholder="" v-model.trim="keyword" @keydown.enter="search" maxlength="30"  autocomplete="false">
          <img src="../../assets/search_button.png" @click="search">
        </div>
      </div>
      <!-- 关于真相科技 -->
      <div class="about_truthso">
        <div class="menu-down">
          <a href="#" style="margin-right:5px">关于真相<span class="menu-down-icon"></span></a>
          <div class="menu-down-con">
            <div>
              <a href="http://www.truthso.com/about/" target="_blank">真相科技</a>
              <a href="http://www.truthelectronic.com" target="_blank">真相电子</a>
            </div>
          </div>
        </div><span class="splitS">|</span>
        <a href="http://www.inic.org.cn/" target="_blank" style="margin-right:5px">中国互联网法治研究院</a><span class="splitS">|</span>
        <a href="https://www.legalxchain.com" target="_blank" style="margin-right:5px">legalXchain司法联盟链</a><span class="splitS">|</span>
        <a href="https://www.ip360.net.cn/" target="_blank" style="margin-right:5px" >IP360全方位数据权益保护平台</a><span class="splitS">|</span>
        <a href="https://www.xcontract.cn" target="_blank">Xcontract智能签约平台</a>
      </div>

      <!-- 用户状态及信息 -->
      <div class="h_user">
        <div v-if="hasLogin">
          <!--<span @click="goPersonalCenter">{{user.loginAccount}}</span>-->
          <span @click="goPersonalCenter" class="login_account account_action">{{$store.state.user.loginAccount}}</span>
          <span class="split">|</span>
          <span @click="logout" class="account_action">退出</span>
        </div>
        <div v-else>
          <span @click="openPopup('loginWin')" class="account_action">登录</span>
          <span class="split">|</span>
          <span @click="openPopup('registerWin')" class="account_action">注册</span>
        </div>
      </div>

    </div>
    <div class="header_bottom_line" v-show="$route.path=='/'">
      <div class="lightSpot"></div>
      <div class="lightSpotLine"></div>
    </div>
  </header>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: 'sheader',
    // props: {
    //   user: {
    //     loginAccount:''
    //   }
    // },
    mounted(){
      let user = this.$getLocalStorage('IP360', 'user');
      if(user){
        this.user = user;
        this.$store.commit('login', this.user);
      }
      let keyword = this.$router.currentRoute.query.keyword;
      if(keyword){
        this.keyword = decodeURIComponent(this.$router.currentRoute.query.keyword);
      }

    },
    data () {
      return {
        userID:'',
        keyword:''
      }
    },
    methods: {
      openPopup (type) {
          this.$store.commit('showPopWindow', type);
//        this.$emit('openPopup', type);
      },
      logout () {
        let local = JSON.parse(decodeURI(localStorage.getItem('IP360')));
        this.$axios.get('/webapi/user/login/logout',{
          params: {
            token: local.user.token
          }
        })
        .then((res)=>{
          let path = this.$router.currentRoute.path;
          console.log('path is :', path);
          localStorage.removeItem('IP360');
          this.$store.commit('logout');
          this.$router.push('/');
          // if(path.indexOf('/results/') == 0){
          //   this.$router.go(0);
          // }else{
          //   this.$router.push('/');
          // }
//          if(res.data.code === 200){
//            localStorage.removeItem('IP360');
//            this.$store.commit('logout');
//            this.$router.push('/');
//          }else if(res.data.code == 102 || res.data.code == 103){
//            this.$store.commit('logout');
//            this.$router.push('/');
//          }else{
//
//          }
        })
        .catch((error)=>{
          console.log(error);
        })
      },
      search () {
        if(this.keyword){
          let current = this.$router.currentRoute;
          let currentKeyword = decodeURIComponent(this.$router.currentRoute.query.keyword);
//          console.log('currentKeyword', currentKeyword);
//          console.log('this keyword', this.keyword);

          if(currentKeyword && (currentKeyword.trim() == this.keyword)){
//            alert('same page num');
            if(current.query.pageNum == 1){
              this.$router.go(0);
            }else{
//            alert('diff page num');
              let path = this.$router.history.current.path;
              if(path.indexOf('/results') != 0){
                path = '/results/text';
              }
              let newQuery = {
                keyword:encodeURIComponent(this.keyword),
                pageNum:1
              };
              console.log('new query: ', newQuery);
              this.$router.push({path,query:newQuery});
            }
          }else{
//            alert('diff keyword');
            this.$store.state.keyword = this.keyword;
            let path = this.$router.history.current.path;
            if(path.indexOf('/results') != 0){
              path = '/results/text';
            }
            let newQuery = {
              keyword:encodeURIComponent(this.keyword),
//              keyword:this.keyword,
              pageNum:1
            };
            console.log('new query: ', newQuery);
            this.$router.push({path,query:newQuery});
//            this.$router.go(0);
          }
        }else{
          this.$store.dispatch('showMsgModal',{
            autoClose:true,
            info:'搜索内容不能为空'
          });
        }
      },
      goPersonalCenter () {
          this.$router.push('/personal_center/my_evidences')
      },
      keywordCheck(){
        this.keyword = this.$cutString(this.keyword, 30, false);
      }
    },
    computed: {

      //获取 store 中的相应状态
      ...mapState({
        showSubBar: state => state.subBar,
        hasLogin: state => state.hasLogin,
        getKeyword: state => state.keyword,
        showHeader: state => state.header,
        isIndex: state => state.isIndex,
        isFeedback: state => state.isFeedback,
        isResults: state => state.isResults,
        isPersonal: state => state.isPersonal,
      })
    },
    watch: {
      '$route' (to, from) {
        //刷新参数放到这里里面去触发就可以刷新相同界面了
//        console.log('router change in sheader');
        let params = this.$queryUrlParams(to.fullPath);
        if(params.keyword){
          this.keyword = decodeURIComponent(params.keyword);
        }
      },
      showSubBar () {
        // if(this.showSubBar){
        //     $('header').css({
        //       'background-color':'#fff'
        //     })
        // } else {
        //     $('header').css({
        //       'background-color':'rgba(255,255,255,0)'
        //     })
        // }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*---header common---*/
  header {
    width: 100%
  }

  .h_container {
    height: 62px;
    // overflow: hidden;

  }
  /*logo和输入框*/
  .h_maincon_wrap{
    float: left;
  }
  .h_maincon_wrap .h_logo {
    margin-top: 26px;
    float: left;
    height: 28px;
    width: 102px;
    margin-left: 110px;
  }
  .h_maincon_wrap .h_logo img{
    border:0;
  }
  .h_maincon_wrap .h_search_box {
    float: left;
    width: 434px;
    height: 38px;
    margin-top: 21px;
    margin-left: 50px;
  }
  .h_maincon_wrap .h_search_box input {
    box-sizing: border-box;
    height: 38px;
    width: 433px;
    font-size: 16px;
    padding-left: 10px;
    border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(163, 41, 53);
    border-image: initial;
  }
  .h_maincon_wrap .h_search_box img {
    width: 43px;
    height: 38px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  /*用户状态*/
  .h_user {
    margin-top: 33px;
    font-size: 14px;
    line-height: 14px;
    min-width: 110px;
    font-weight: 600;
    margin-left: 50px;
    float: left;
  }
  .h_user span {
    cursor: pointer;
  }
  .h_user .login_account{
    /*color: #a32935;*/
    /*max-width: 213px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;*/
  }
  .h_user .split {
    margin: 0 8px;
    font-size: 10px;
    font-weight: normal;
    cursor: default;
     color: #aaa;
  }
  .splitS{
    margin: 0 8px;
    font-size: 10px;
    font-weight: normal;
    cursor: default;
    color: #aaa;
  }
  /*关于真相科技*/
  .about_truthso{
    margin-top: 33px;
    color: #555;
    font-size: 12px;
    line-height: 12px;
    float: right;
    margin-right: 30px;
  }
  .about_truthso a{
    color: #555;
    text-decoration: none;
  }



  /*---header personal*/
  .pos_personal{
    background: #232c33;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
  }
  .pos_personal .h_logo{
    margin-left: 21px;
  }
  .pos_personal .h_search_box{
    margin-left: 25px;
  }
  .pos_personal .about_truthso{
    margin-right: 25px;
  }
  .pos_personal .h_user,
  .pos_personal .about_truthso a{
    color: #9499a6;
  }
  .pos_personal .about_truthso a:hover,
  .pos_personal .h_user .account_action:hover {
    color: #c45;
  }
  .pos_personal .login_account{
    color: #c45;
  }
  .pos_personal .h_search_box input{
    border: 0;
  }
  /*---header index*/
  .pos_index{}
  .pos_index .h_container {
    width: 1250px;
    margin: 0 auto;
  }
  .pos_index .h_maincon_wrap{
    display: none;
  }
  .pos_index  .about_truthso a{
    color: #e7e2e2;
  }
  .pos_index .h_user span{
    color: #cacaca;
  }
  .pos_index  .about_truthso a:hover{
    color: #DE2A29;
  }
  .pos_index  .h_user .account_action:hover {
    color: #fff;
  }

  /*---header results*/
  .pos_results{}
  .pos_results .h_container {
    width: 1250px;
    margin: 0 auto;
  }


  /*---header feedback*/
  .pos_feedback{}
  .pos_feedback .h_container {
    width: 1250px;
    margin: 0 auto;
  }
  .Dot{
    width: 3px;
    height: 3px;
    display: inline-block;
    background: #fff;
    border-radius: 50%;
   
  }
  .header_bottom_line{
    width: 100%;
    height: 3px;
    background:url('../../assets/line.gif') no-repeat;
    background-size: 100%;
    position: relative;
    // .lightSpot{
    //   width: 3px;
    //   height: 3px;
    //   background: #fff;
    //   left: 150px;
    //   top: 0px;
    // }
    // .lightSpotLine{
    //   width: 75px;
    //   top:0px;
    //   left:80px;
    //   --colorA: #fff;
    // border-radius: 50%;
    // border-top: 2px solid #fff;
    // filter: 
    //     drop-shadow(0 0 1px var(--colorA))
    //     drop-shadow(0 0 10px var(--colorA))
    //     drop-shadow(0 0 10px var(--colorA))
    //     drop-shadow(0 0 30px var(--colorA));
    
    // }
  }
  .about_truthso .menu-down{
    position: relative;
    float:left;
    .menu-down-icon{
      display: inline-block;
      width: 14px;
      height: 14px;
      background: url("../../assets/images/common/menu_bottom_nor.png") no-repeat;
      background-position: center;
      background-size: 100% 100%;
      padding-left: 3px;
      float: right;
      margin-top: -1px;
    }
  }
  .menu-down:hover .menu-down-icon{
    background: url("../../assets/images/common/menu_bottom.png") no-repeat;
    background-position: center;
    background-size: 100% 100%;
    // transition: transform 0.2s;
    transform: rotateX(180deg);
  }
  .menu-down:hover a{
    color: #DE2A29;
  }
  .menu-down:hover .menu-down-con{
    display: block;
  }
  .menu-down-con{
    width: 128px;
    height: 80px;
    position: absolute;
    top: 0px;
    left: 50%;
    margin-left: -64px;
    z-index: 99;
    padding-top: 30px;
    display: none;
    div{
      width: 100%;
      height: 100px;
      background: #fff;
      a{
        line-height: 50px;
        text-align: center;
        font-size: 14px;
        width: 100%;
        display: block;
        font-weight: 500;
        color: #505050 !important;
      }
      a:hover{
        color: #DE2A29 !important;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SHeader.vue?66670cd7